import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_STEP_CONNECTIVITY_KEY, DIAGNOSTIC_STEP_RESULTS_VALUE } from "@/constants/diagnostics";
import { useIsOnline } from "@/hooks/useIsOnline";
import { api } from "@/services/api";
import { setDiagnosticsStep } from "@/store/features/diagnostics/slice";
import { useAppDispatch } from "@/store/hooks";
import { Button } from "@/ui";
import DiagnosticsSection from "../DiagnosticsSection";

const Connectivity = () => {
  const { t } = useTranslation();

  const isOnline = useIsOnline();
  const [status, setStatus] = useState<'loading' | 'success' | 'failed'>('loading');

  const dispatch = useAppDispatch();

  const checkServerHealth = useCallback(async () => {
    try {
      await api.get('/health');
      setStatus('success');
    } catch {
      setStatus('failed');
    }
  }, []);

  useEffect(() => {
    checkServerHealth();
  }, [checkServerHealth]);

  const onClickOk = () => {
    dispatch(setDiagnosticsStep(DIAGNOSTIC_STEP_RESULTS_VALUE));
  };

  const onClickRefresh = () => {
    window.location.reload();
  };

  return (
    <DiagnosticsSection id={DIAGNOSTIC_STEP_CONNECTIVITY_KEY}>
      <div className="section-wrapper">
        <div className="section-content">
          {status === 'loading' ? (
            <>
              <h2>{t('checking_connection_status')}</h2>
              <p>{t('checking_connection_status_description')}</p>
            </>
          ) : isOnline && status === 'success' ? (
            <>
              <h2>{t('connection_success')}</h2>
              <p>{t('connection_success_description')}</p>
              <Button onClick={onClickOk}>{t('ok')}</Button>
            </>
          ) : (
            <>
              <h2>{t('connection_failed')}</h2>
              <p>{t('connection_failed_description')}</p>
              <Button onClick={onClickRefresh}>{t('refresh_page')}</Button>
            </>
          )}
        </div>
        <div className="section-image">
          <img src="/images/connection-success.webp" alt={t('connection_success')} />
        </div>
      </div>
    </DiagnosticsSection>
  );
};

export default Connectivity;